module.exports = __webpack_public_path__ + "img/icon_profit.44e7b1d2.png";